import { FetchCrudData } from '../../models';
import { ReportsService } from '../../services';
import { ActionType } from './types';

export const getReports = (queryParams: FetchCrudData) => ({
  type: ActionType.GET_REPORTS,
  payload: ReportsService.getReports(queryParams),
});
export const getMoreReports = (queryParams: FetchCrudData) => ({
  type: ActionType.GET_MORE_REPORTS,
  payload: ReportsService.getReports(queryParams),
});
export const getFilterOptions = (storeId: string | null, departmentTemplateId: string | null) => ({
  type: ActionType.GET_REPORT_FILTER_OPTIONS,
  payload: ReportsService.getFilterOptions(storeId, departmentTemplateId),
});
